import { PagingMetaDto } from "../../dtos/_system";

export class PagingMeta {
  current_page = -1;
  from = -1;
  last_page = -1;
  path = "";
  per_page = -1;
  to = -1;
  total = -1;

  nextPage: number | null = null;

  constructor(dto: PagingMetaDto) {
    this.current_page = dto.current_page;
    this.from = dto.from;
    this.last_page = dto.last_page;
    this.path = dto.path;
    this.per_page = dto.per_page;
    this.to = dto.to;
    this.total = dto.total;

    const targetNextPage = dto.current_page + 1;

    this.nextPage = targetNextPage > dto.last_page ? null : targetNextPage;
  }
}
